export const uiPricingGrid = {
    name: 'UI Pricing Grid',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        plans: {
            name: 'Plans',
            type: 'Array',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ size: { min: 1, max: 4 } }],
            items: {
                type: 'Link',
                validations: [{ linkContentType: ['uiPricingPlan'] }],
                linkType: 'Entry'
            }
        }
    }
};
//# sourceMappingURL=uiPricingGrid.js.map